import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function createContext(rootName, defaultContext) {
  const Context = /*#__PURE__*/React.createContext(defaultContext);
  function Provider(props) {
    const {
      children,
      ...context
    } = props;
    const value = React.useMemo(() => context, Object.values(context));
    return /*#__PURE__*/_jsx(Context.Provider, {
      value: value,
      children: children
    });
  }
  function useContext(consumerName) {
    const context = React.useContext(Context);
    if (context) {
      return context;
    }
    if (defaultContext !== undefined) {
      return defaultContext;
    }
    throw new Error(`\`${consumerName}\` must be used within \`${rootName}\``);
  }
  Provider.displayName = `${rootName}Provider`;
  return [Provider, useContext];
}